import { useState } from 'react';
import { Menu as MenuAntd } from 'antd';

import { useCurrentKey } from './useCurrentKey';
import { useMenuItems } from './useMenuItems';

import { MenuContainer } from './style';

export const Menu = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <MenuContainer collapsible collapsed={collapsed} onCollapse={setCollapsed}>
      <MenuAntd mode='inline' items={useMenuItems()} selectedKeys={useCurrentKey()} />
    </MenuContainer>
  );
};
